import styled from 'styled-components';
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const FilterButtonDefaultBox = styled.a`
    width: 103px;
    height: 32px;
    background: ${props => props.theme.components.newLiveCasino.colors.miniOrbit.filterButtonBackgroundNormal};
    border: 2px solid ${props => props.theme.components.newLiveCasino.colors.miniOrbit.filterBorder};
    border-radius: 55px;
    opacity: 1;
    margin: 7px 2px;
    align-items: center;
    display: flex;
    justify-content: center;

    text-align: center;
    ${({theme}) => theme.font.presets.medium};
    font-size: 11px;
    letter-spacing: 0px;
    line-height: normal;
    color: ${props => props.theme.components.newLiveCasino.colors.filterButtonLabel};
    opacity: 1;

  &.${ACTIVE} {
    background: ${props => props.theme.components.newLiveCasino.colors.miniOrbit.filterButtonBackgroundActive};
    color: ${props => props.theme.colors.textLight};
  }
`;